import React, { Ref, forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';

import { StyledEmbedModalWithGreenHeader } from './Layout';
import { ModalSize } from 'src/presentation/components/pages/shared/EmbedModal';

type ShowModalProps = {
  subscribe: (params: unknown) => void;
};

export type ModalWrapperRef = {
  show: ({ subscribe }: ShowModalProps) => void;
  close: () => void;
  toggle: (item) => void;
};

type ModalWrapperProps = {
  content: React.ReactNode;
  className?: string;
  title?: string;
};

const ModalWrapper = forwardRef(({ content, className, title }: ModalWrapperProps, ref: Ref<ModalWrapperRef>) => {
  const refCallbacks = useRef<{ subscribe: (params: unknown) => void } | null>(null);

  const [modalVisible, setModalVisible] = useState(false);

  useImperativeHandle(ref, () => ({
    show({ subscribe }: ShowModalProps) {
      refCallbacks.current = { subscribe };

      setModalVisible(true);
    },
    close: () => setModalVisible(false),
    toggle: item => {
      setModalVisible(!item.enabled);
    },
  }));

  const handleClose = () => {
    setModalVisible(false);
    refCallbacks.current = null;
  };

  if (!modalVisible) {
    return null;
  }

  return (
    <StyledEmbedModalWithGreenHeader
      className={className}
      content={content}
      disableOutsideClick={true}
      modalSize={ModalSize.DEFAULT}
      onCancel={handleClose}
      title={title}
    />
  );
});

export const StyledLabel = styled.label`
  align-self: flex-start;
  color: ${p => p.theme.colors.gray700};
  font-family: Inter;
  font-size: 13px;
  font-weight: 400;
  line-height: 21.06px;
  min-height: 18px;
  margin-bottom: 8px;
`;

export const SimpleInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export default ModalWrapper;
